import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-frueh-eintritt',
    templateUrl: './calendar-field.component.html'
} )
export class EarliestCommencementDateFormComponent extends AbstractFieldComponent<Date> {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.earliestCommencementDate' );
    }

    set value( t: Date | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.earliestCommencementDate = t;
        }
    }

    get value(): Date | undefined {
        return this.jobapplication?.earliestCommencementDate;
    }
}
